<template>
  <div class="card" v-loading="loading">
    <div class="card-header bg-white d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Detalle de Tipo de Inventario</h5>
      <el-button size="small" icon="el-icon-back" @click="$emit('back')">Volver</el-button>
    </div>
    <div class="card-body" v-if="inventoryType">
      <div class="row mb-4">
        <div class="col-md-6">
          <strong>Nombre:</strong> {{ inventoryType.name }}
        </div>
        <div class="col-md-6">
          <strong>Código:</strong> <span class="badge badge-secondary">{{ inventoryType.code }}</span>
        </div>
      </div>
      
      <div class="row mb-4" v-if="inventoryType.countries && inventoryType.countries.length">
          <div class="col-12">
               <strong>Países:</strong>
               <div class="mt-1">
                   <span v-for="country in inventoryType.countries" :key="country.id" class="badge badge-info mr-1">
                       {{ country.name }}
                   </span>
               </div>
          </div>
      </div>

      <h6 class="border-bottom pb-2 mb-3">Estructura del Inventario</h6>
      
      <div class="structure-preview">
          <div v-for="section in sortedSections" :key="section.id" class="card mb-3 border-light bg-light">
              <div class="card-header py-2">
                  <strong>{{ section.name }}</strong>
                  <span class="float-right badge badge-light">Orden: {{ section.order }}</span>
              </div>
              <div class="card-body py-2">
                  <div class="row">
                      <div class="col-md-4 col-sm-6 mb-1" v-for="col in section.columns" :key="col.id">
                          <i class="el-icon-check text-success"></i> <small>{{ col.name }}</small>
                      </div>
                  </div>
              </div>
          </div>
      </div>

    </div>
    <div class="card-body text-center" v-else-if="!loading">
        <p class="text-muted">No se encontró información.</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      inventoryType: null,
    };
  },
  computed: {
      sortedSections() {
          if (!this.inventoryType || !this.inventoryType.inventory_columns) return [];
          
          const sectionsMap = {};
           this.inventoryType.inventory_columns.forEach(col => {
                const sectionId = col.slq_inventory_section_id;
                // Use pivot order if available, else 0
                const order = col.pivot ? col.pivot.order_section : 0; 
                // Need section name... inventoryType.inventory_columns has 'inventorySection' relation loaded?
                // Backend 'filterByCode' repository method has ->with(['inventoryColumns','inventoryColumns.inventorySection'])
                // But 'detail' (used by get by id) has ->with(['inventoryColumns'])
                // I should assume 'inventorySection' might NOT be loaded in 'inventoryColumns' relation in 'detail' method?
                // Let's check InventoryRepository.php detail method.
                // It has ->with(['inventoryColumns']). Relation inventoryColumns belongsTo SlqInventorySection. 
                // But Laravel doesn't auto-load nested relations unless specified.
                // SlqInventoryRepository.php line 37: ->with(['inventoryColumns'])->where('id', $id)->first();
                // SlqInventoryColumn model has 'inventorySection' relation.
                // I should verify if I need to update Repository to eager load section name.
                // Or I can just display columns and minimal info.
                // Ideally I update repository to ->with(['inventoryColumns.inventorySection']).
                
                if (!sectionsMap[sectionId]) {
                    sectionsMap[sectionId] = {
                        id: sectionId,
                        name: col.inventory_section ? col.inventory_section.name : `Sección ${sectionId}`, // Fallback
                        order: order,
                        columns: []
                    };
                }
                sectionsMap[sectionId].columns.push(col);
            });
            
            return Object.values(sectionsMap).sort((a, b) => a.order - b.order);
      }
  },
  async mounted() {
    this.loading = true;
    const data = await this.filterInventoryType(this.id);
    this.inventoryType = data;
    this.loading = false;
  },
  methods: {
    ...mapActions("inventoryTypes", ["filterInventoryType"]),
  },
};
</script>

<style scoped>
.structure-preview {
    max-height: 500px;
    overflow-y: auto;
}
</style>
